<template>
  <nav class="breadcrumbs">
    <div class="breadcrumbs__inner">
      <div class="breadcrumbs__inner-scroll">
        <ul class="breadcrumbs__list container">
          <li class="breadcrumbs__item">
            <router-link-modified :to="isRouteNameMixin('home') ? null : {name: 'home'}"
                                  key="main"
                                  class="breadcrumbs__link"
            >{{$tGlobal('Main')}}
            </router-link-modified>
            <BaseSvg name="ico-arrow-light"/>
          </li>
          <!-- links -->
          <li v-for="(item, index) in links"
              :key="item.id"
              class="breadcrumbs__item">
            <router-link-modified v-if="item.route"
                                  :to="item.route"
                                  class="breadcrumbs__link">
              {{item.name}}
            </router-link-modified>
            <div v-else class="breadcrumbs__link">
              {{item.name}}
            </div>
            <BaseSvg v-if="index !== links.length - 1" name="ico-arrow-light"/>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="backRoute"
         class="breadcrumbs__back-btn-wrap container">
      <router-link-modified :to="backRoute"
                            class="breadcrumbs__back-btn  base-link">
        <BaseSvg name="ico-arrow-light"/>
        <span class="tag-btn__text">{{$tGlobal('To back')}}</span>
      </router-link-modified>
    </div>
  </nav>
</template>

<script>

  export default {
    name: "TheBreadcrumbs",
    props: {
      links: {
        type: Array,
        default: () => []
      },
      backRoute: {
        type: Object
      }
    },
    data() {
      return {}
    },
    methods: {
      createMeta() {
        const lang = this.$route.params.lang
        let basePath = window.location.origin
        if (lang) {
          basePath = basePath + '/' + lang
        }

        const tag = getTag()
        const content = {
          "@context": "http://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": []
        }

        content.itemListElement.push({
          "@type": "ListItem",
          "position": 1,
          "item": {
            "@id": basePath + '/',
            "name": this.$tGlobal('Main')
          }
        })

        this.links.forEach((link, index) => {
          if (!link.href) return

          let href = link.href

          if (!href.startsWith('/')) {
            href = '/' + href
          }

          if (!href.endsWith('/')) {
            href += '/'
          }

          href = basePath + href

          content.itemListElement.push({
            "@type": "ListItem",
            "position": index + 2,
            "item": {
              "@id": href,
              "name": link.name
            }
          })
        })

        tag.innerHTML = JSON.stringify(content)
        document.head.appendChild(tag)
      }
    },
    mounted() {
      this.createMeta()
    },
    watch: {
      links() {
        this.createMeta()
      }
    },
    beforeDestroy() {
      deleteTag()
    }
  }

  function getTag() {
    return document.getElementById('breadcrumbs-json') || createTagScriptJSON()
  }

  function deleteTag() {
    const teg = document.getElementById('breadcrumbs-json')
    if (teg) document.head.removeChild(teg)
  }

  function createTagScriptJSON() {
    const tag = document.createElement('script')
    tag.setAttribute('type', 'application/ld+json')
    tag.setAttribute('id', 'breadcrumbs-json')

    return tag
  }
</script>

<style>

</style>
